<img id="image" [src]="imagePath" />
